import { TypeChecker } from '@attain-apps/type-guards'

import * as node from '../node'
import type { ResultProducer } from '../result-producer'

import type { Edge } from './edge'

/**
 * Represents an {@link Edge} between {@link Node Nodes} where one node is
 * used in one of the {@link Expression Expressions} of the other node.
 */
export interface ForConsumption extends Edge, ResultProducer {
  readonly node: node.OfAnyType
  /**
   * When `true`, the consuming node should filter out records that do not
   * have associated records in the consumed node
   *
   * @example
   * // Room <--- consuming (isRequired = true) --- Room Type
   * // => Only return rooms with room types
   *
   * // Room <--- consuming (isRequired = false) --- Room Type
   * // => Return all rooms, some rooms might have `null` for the room type
   */
  readonly isRequired: boolean
}
export namespace ForConsumption {
  export const isValidNode: TypeChecker<ForConsumption['node']> =
    TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.exclude(
        node.OfAnyType.isOfAnyType,
        node.ForValue.isForValue,
      ),
    ).usingAlias("query.Graph.Edge.ForConsumption['node']")

  export function stringify(edge: ForConsumption): string {
    return JSON.stringify({
      isRequired: edge.isRequired.toString(),
      node: edge.node.id,
      resultsAsSingleton: edge.resultsAsSingleton.toString(),
    } satisfies Record<keyof ForConsumption, string | undefined>)
  }
}
